module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-100.3bb81c89.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-100.png
// module id = 3320
// module chunks = 11